import { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { marked } from "marked";
import { NodeHtmlMarkdown } from "node-html-markdown";

function DTable({ setchat_data, isEditable, data1 }: any) {
  const [content, setContent] = useState("");

  useEffect(() => {
    try {
      let newContent = "";
      const data = JSON.parse(data1);
      newContent = marked(data);
      setContent(newContent);
    } catch (err) {
      setContent(data1?.toString());
    }
  }, [data1]);

  const handleEditorChange = (newContent) => {
    const markdownContent = NodeHtmlMarkdown.translate(newContent);
    setchat_data(JSON.stringify(markdownContent));
    setContent(newContent);
  };

  const convertTableToMarkdown = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const table = doc.querySelector("table");

    const rows = Array.from(table.rows);
    let markdownTable = "";

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.cells);
      const rowMarkdown = cells
        .map((cell) => cell.textContent.trim())
        .join(" | ");

      markdownTable += `| ${rowMarkdown} |\n`;

      if (rowIndex === 0) {
        const separator = cells.map(() => "---").join(" | ");
        markdownTable += `| ${separator} |\n`;
      }
    });
    return markdownTable;
  };

  return (
    <>
      <style>
        {`
                         .sun-editor .se-wrapper .se-wrapper-wysiwyg {
                              display: block;
                              height: 100% !important;
                         }
                    `}
      </style>
      <style>
        {`
                    table {
                              width: 100%;
                              border-collapse: collapse;
                              }
                              td, th {
                              border: 1px solid #d9d9d9;
                              padding: 8px;
                              text-align: left;
                              }
                              th {
                              background-color: #d9d9d9;
                              }
                              table tr:hover {
                              background-color: #f5f5f5;
                              }
               `}
      </style>
      {isEditable ? (
        <SunEditor
          setContents={content}
          onChange={handleEditorChange}
          setOptions={{
            buttonList: [["undo", "redo"], ["fullScreen"], ["preview"]],
          }}
        />
      ) : (
        <div
          id="content-to-pdf"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
}

export default DTable;
